export { BottomConsoleComponent } from './bottom-console.component';
export { PatchesConsoleTabComponent } from './patches-console-tab';
export { ProblemsConsoleTabComponent } from './problems-console-tab';
